module.exports = __webpack_public_path__ + "img/medium2.f79f2960.svg";